import React, { useState, useCallback, useMemo } from 'react';
import { QrCode, Calendar, Clock, MapPin, Phone, User, Mail, CheckCircle, ShoppingCart, Plus, Minus } from 'lucide-react';
import { useEffect } from 'react';

const QRBookingApp = () => {
    const [queueResponse, setQueueResponse] = useState(null);
    const [currentStep, setCurrentStep] = useState('form'); // form, success
const [whatsappNumbers, setWhatsappNumbers] = useState({});
    const [productItems, setProductItems] = useState([]);
    const [formData, setFormData] = useState({
      name: '',
      phone: '',
      email: '',
      gender: '',
      service: '',
      birthday: ''
    });
    
    const [activeService, setActiveService] = useState(() => {
        return 'kitchen';
      });
      const [expandedItems, setExpandedItems] = useState(new Set());

    const [kitchenCart, setKitchenCart] = useState([]);
    const [servicesCart, setServicesCart] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [bookedService, setBookedService] = useState('kitchen');
    const [showOrderForm, setShowOrderForm] = useState(false);
    const [orderFormData, setOrderFormData] = useState({
      name: '',
      phone: ''
    });
    const [menuItems, setMenuItems] = useState([]);


    const [isOrdering, setIsOrdering] = useState(false);

    const getCartTotal = useCallback((cart) => {
        return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
      }, []);

const isValidPhoneNumber = (phone: string) => {
  const cleaned = phone.replace(/\s+/g, '');
  return /^(\+7|8)7\d{9}$/.test(cleaned);
};

const toggleItemExpanded = useCallback((itemId, itemType) => {
    const key = `${itemType}-${itemId}`;
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      return newSet;
    });
  }, []);
  
  const isItemExpanded = useCallback((itemId, itemType) => {
    return expandedItems.has(`${itemType}-${itemId}`);
  }, [expandedItems]);
  
  const shouldTruncate = useCallback((text, maxLength = 60) => {
    return text && text.length > maxLength;
  }, []);
  
  const getTruncatedText = useCallback((text, maxLength = 60) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }, []);
useEffect(() => {
  const fetchMenuFromAPI = async () => {
    try {
      const response = await fetch('/api/service/list/');
      if (!response.ok) return;

      const data = await response.json();
      const menu = [];
      console.log(data.services)
      if (data.services?.hot_meal?.length) {
        menu.push({
          category: 'Горячие блюда',
          items: data.services.hot_meal.filter(item => item.is_active)
        });
      }
      if (data.services?.hot_snacks?.length) {
        menu.push({
          category: 'Горячие закуски',
          items: data.services.hot_snacks.filter(item => item.is_active)
        });
      }
if (data.services?.hot_drinks?.length) {
        menu.push({
          category: 'Горячие напитки',
          items: data.services.hot_drinks.filter(item => item.is_active)
        });
      }
if (data.services?.pivo?.length) {
        menu.push({
          category: 'Пиво',
          items: data.services.pivo.filter(item => item.is_active)
        });
      }
if (data.services?.snack_for_pivo?.length) {
        menu.push({
          category: 'Закуски к пиву',
          items: data.services.snack_for_pivo.filter(item => item.is_active)
        });
      }
if (data.services?.garnier?.length) {
        menu.push({
          category: 'Гарниры',
          items: data.services.garnier.filter(item => item.is_active)
        });
      }
if (data.services?.salad?.length) {
        menu.push({
          category: 'Салаты',
          items: data.services.salad.filter(item => item.is_active)
        });
      }
if (data.services?.tea?.length) {
        menu.push({
          category: 'К чаю',
          items: data.services.tea.filter(item => item.is_active)
        });
      }

if (data.services?.baking_for_tea?.length) {
        menu.push({
          category: 'Выпечка к чаю',
          items: data.services.baking_for_tea.filter(item => item.is_active)
        });
      }
if (data.services?.fresh_juice?.length) {
        menu.push({
          category: 'Свежевыжатые соки',
          items: data.services.fresh_juice.filter(item => item.is_active)
        });
      }
if (data.services?.natural_drinks?.length) {
        menu.push({
          category: 'Натуральные соки',
          items: data.services.natural_drinks.filter(item => item.is_active)
        });
      }
if (data.services?.cold_drinks?.length) {
        menu.push({
          category: 'Холодные напитки',
          items: data.services.cold_drinks.filter(item => item.is_active)
        });
      }
if (data.services?.fish_for_pivo?.length) {
        menu.push({
          category: 'Рыба пиву',
          items: data.services.fish_for_pivo.filter(item => item.is_active)
        });
      }

      if (data.services?.snacks?.length) {
        menu.push({
          category: 'Закуски',
          items: data.services.snacks.filter(item => item.is_active)
        });
      }
      if (data.services?.drinks?.length) {
        menu.push({
          category: 'Напитки',
          items: data.services.drinks.filter(item => item.is_active)
        });
      }

      setMenuItems(menu);
    } catch (err) {
      console.error('Ошибка загрузки меню:', err);
    }
  };

  
  const fetchProductsFromAPI = async () => {
    try {
      const response = await fetch('/api/product/');
      if (!response.ok) return;
  
      const data = await response.json();
      // Handle the nested structure - products are in data.products array
      if (data.products && Array.isArray(data.products)) {
        setProductItems(data.products.filter(item => item.is_active));
      }
    } catch (err) {
      console.error('Ошибка загрузки услуг:', err);
    }
  };
const fetchWhatsappNumbers = async () => {
  try {
    const response = await fetch('/api/whatsapp-numbers/');
    if (!response.ok) return;
    
    const data = await response.json();
    console.log(data.whatsapp_numbers)
    setWhatsappNumbers(data.whatsapp_numbers || {});
  } catch (err) {
    console.error('Ошибка загрузки WhatsApp номеров:', err);
  }
};

fetchWhatsappNumbers();

  fetchProductsFromAPI();

  fetchMenuFromAPI();
}, []);


const getWhatsappNumberByType = useCallback((type) => {
  const numbers = whatsappNumbers[type];
  console.log("number", numbers)
  return numbers[0].phone_number
}, [whatsappNumbers]);

const sendProductOrderToService = useCallback(async () => {
  if (isOrdering) return;             // guard against double-submit
  if (!orderFormData.phone || servicesCart.length === 0) {
    alert('Заполните все данные и добавьте услуги в заказ');
    return;
  }

  setIsOrdering(true);

  const orderDetails = servicesCart.map(item => `${item.name} x${item.quantity} = ${item.price * item.quantity} ₸`).join('\n');
  const total = getCartTotal(servicesCart);

  const requestBody = {
    phonenumber: orderFormData.phone,
    name: orderFormData.name || 'Гость',
    order: `${orderDetails}\nИтого: ${total} ₸`,
    price: total  // Add the total price here
  };

  try {
    const response = await fetch('/api/product/order/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Ошибка при отправке заказа:', errorData);
      alert('Не удалось отправить заказ. Попробуйте позже.');
      return;
    }

    const message = `Новый заказ на услуги:
Имя: ${orderFormData.name}
Телефон: ${orderFormData.phone}

Заказ:
${orderDetails}

Итого: ${total} ₸`;
    console.log(getWhatsappNumberByType('bath'))
    let  number = getWhatsappNumberByType('bath') 
    let cleanNumber = number.replace(/^\+/, "");
    console.log(cleanNumber)
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;

    setServicesCart([]);
    setOrderFormData({ name: '', phone: '' });
    setShowOrderForm(false);
  } catch (error) {
    console.error('Ошибка сети:', error);
    alert('Ошибка сети. Попробуйте позже.');
  } finally {
    setIsOrdering(false);
  }
}, [orderFormData, servicesCart, getCartTotal]);

const sendKitchenOrderToService = useCallback(async () => {
  if (isOrdering) return;             // guard against double-submit
  if (!orderFormData.phone || kitchenCart.length === 0) {
    alert('Заполните все данные и добавьте блюда в заказ');
    return;
  }

  setIsOrdering(true);

  const orderDetails = kitchenCart.map(item => `${item.name} x${item.quantity} = ${item.price * item.quantity} ₸`).join('\n');
  const total = getCartTotal(kitchenCart);

  const requestBody = {
    phonenumber: orderFormData.phone,
    name: orderFormData.name || 'Гость',
    order: `${orderDetails}\nИтого: ${total} ₸`,
  };

  try {
    const response = await fetch('/api/service/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Ошибка при отправке заказа:', errorData);
      alert('Не удалось отправить заказ. Попробуйте позже.');
      return;
    }
        const message = `Новый заказ:
Имя: ${orderFormData.name}
Телефон: ${orderFormData.phone}

Заказ:
${orderDetails}

Итого: ${total} ₸`;

    const whatsappUrl = `https://wa.me/${getWhatsappNumberByType('kitchen')}?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;

    setKitchenCart([]);
    setOrderFormData({ name: '', phone: '' });
    setShowOrderForm(false);
  } catch (error) {
    console.error('Ошибка сети:', error);
    alert('Ошибка сети. Попробуйте позже.');
  } finally {
    setIsOrdering(false);
  }
}, [orderFormData, kitchenCart, getCartTotal]);

    useEffect(() => {
        const storedService = 'kitchen';
        setActiveService(storedService);
      
        const savedBooking = localStorage.getItem('bookingInfo');
        if (savedBooking) {
          const booking = JSON.parse(savedBooking);
          const now = Date.now();
          const THIRTY_MIN = 30 * 60 * 1000;
      
          if (now - booking.timestamp < THIRTY_MIN) {
            setFormData(booking.formData);
            setSelectedSlot(booking.selectedSlot);
            setBookedService(booking.bookedService);
      
            if (storedService === booking.bookedService) {
              setCurrentStep('success');
            } else {
              setCurrentStep('form');
            }
          }
        }
      }, []);
      
      

  const services = useMemo(() => [
    { id: 'kitchen', name: 'Кухня и Бар', icon: '🍽️' },
    { id: 'services', name: 'Услуги', icon: '🛎️' }
  ], []);


async function fetchDuration() {
  try {
    const response = await fetch('/api/duration/');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    
    // Return the amount from the first duration object
    if (data.durations && data.durations.length > 0) {
      return parseFloat(data.durations[0].amount);
    }
    
    // Fallback if no durations found
    return 10; // default duration
  } catch (error) {
    console.error('Error fetching duration:', error);
    return 10; // fallback duration
  }
}

 const handleFormSubmit = useCallback(async () => {
  if (isSubmitting) return;            // guard against rapid double-submit
  if (formData.phone && formData.gender) {
    setIsSubmitting(true);

    try {
      // Parse name into first_name and last_name
      const nameParts = formData.name?.trim()?.split(' ').filter(part => part.length > 0) || [];
      const firstName = nameParts[0] || null;
      const lastName = nameParts.slice(1).join(' ') || null;
       const duration = await fetchDuration();
      // Prepare booking data
      const bookingData = {
        phone_number: formData.phone,
        first_name: firstName || 'Гость',
        last_name: lastName || 'Гость',
        gender: formData.gender === 'male' ? 'M' : formData.gender === 'female' ? 'F' : 'M',
        duration: duration,
        birthday: formData.birthday || null
      };

      // Send POST request to create booking
      const response = await fetch('/api/queue/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData)
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Booking created successfully:', result);
        
        // Store the queue response data
        setQueueResponse(result);
        
        // Store booking info for success page
        const bookingInfo = {
          formData,
          bookedService: activeService,
          timestamp: Date.now(),
          queueResponse: result // Store the full response
        };
        
        setBookedService(activeService);
        setCurrentStep('success');
        localStorage.setItem('bookingInfo', JSON.stringify(bookingInfo));

      } else {
        const errorData = await response.json();
        console.error('Booking failed:', errorData);
        alert('Ошибка при создании бронирования. Попробуйте снова.');
      }

    } catch (error) {
      console.error('Network error:', error);
      alert('Ошибка сети. Проверьте подключение и попробуйте снова.');
    } finally {
      setIsSubmitting(false);
    }
  }
}, [formData, selectedSlot, activeService, isSubmitting]);



const formatCurrentDate = () => {
  const today = new Date();
  const day = today.getDate().toString().padStart(2, '0');
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const year = today.getFullYear();
  return `${day}.${month}.${year}`;
};

const formatEstimatedTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleTimeString('ru-RU', { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
};

  const handleInputChange = useCallback((field, value) => {
  if (field === 'phone') {
    const formattedPhone = formatPhoneNumber(value);
    setFormData(prev => ({ ...prev, [field]: formattedPhone }));
  } else {
    setFormData(prev => ({ ...prev, [field]: value }));
  }
}, []);

  const handleServiceChange = useCallback((serviceId) => {
    setActiveService(serviceId);
  
    if (currentStep === 'success' && serviceId !== bookedService) {
      setCurrentStep('form');
    }
  }, [currentStep, bookedService]);
  
const formatPhoneNumber = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // If empty, return +7 7
  if (digits === '') {
    return '+7 7';
  }
  
  let phoneDigits = digits;
  
  // If starts with 8, replace with 7
  if (phoneDigits.startsWith('8')) {
    phoneDigits = '7' + phoneDigits.slice(1);
  }
  
  // If doesn't start with 7, assume it's a local number and add 7
  if (!phoneDigits.startsWith('7')) {
    phoneDigits = '7' + phoneDigits;
  }
  
  // Now format with spaces: +7 777 555 44 11
  let formatted = '+7';
  
  if (phoneDigits.length > 1) {
    formatted += ' ' + phoneDigits.slice(1, 4); // First 3 digits after country code
  }
  
  if (phoneDigits.length > 4) {
    formatted += ' ' + phoneDigits.slice(4, 7); // Next 3 digits
  }
  
  if (phoneDigits.length > 7) {
    formatted += ' ' + phoneDigits.slice(7, 9); // Next 2 digits
  }
  
  if (phoneDigits.length > 9) {
    formatted += ' ' + phoneDigits.slice(9, 11); // Last 2 digits
  }
  
  return formatted;
};


const addToCart = useCallback((item, cartType) => {
    const setCart = cartType === 'kitchen' ? setKitchenCart : setServicesCart;
    
    setCart(prev => {
      const existing = prev.find(cartItem => cartItem.id === item.id);
      if (existing) {
        return prev.map(cartItem =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  }, []);
  
  // Update removeFromCart
  const removeFromCart = useCallback((itemId, cartType) => {
    const setCart = cartType === 'kitchen' ? setKitchenCart : setServicesCart;
    
    setCart(prev => {
      const existing = prev.find(cartItem => cartItem.id === itemId);
      if (existing && existing.quantity > 1) {
        return prev.map(cartItem =>
          cartItem.id === itemId
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        );
      }
      return prev.filter(cartItem => cartItem.id !== itemId);
    });
  }, []);
  
  // Update getCartItemCount
  const getCartItemCount = useCallback((itemId, cartType) => {
    const cart = cartType === 'kitchen' ? kitchenCart : servicesCart;
    const item = cart.find(cartItem => cartItem.id === itemId);
    return item ? item.quantity : 0;
  }, [kitchenCart, servicesCart]);
  
  // Update handleOrder
  const handleOrder = useCallback((cartType) => {
    const cart = cartType === 'kitchen' ? kitchenCart : servicesCart;
    if (cart.length === 0) return;
    setShowOrderForm(true);
  }, [kitchenCart, servicesCart]);
  // Success page - only show for the booked service
  if (currentStep === 'success' && activeService === bookedService) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md text-center">
          {/* Services Menu Bar - Always visible */}
          <div className="bg-gray-50 rounded-2xl shadow-sm mb-6 p-2">
            <div className="grid grid-cols-2 gap-1">
              {services.map(service => (
                <button
                  key={service.id}
                  type="button"
                  onClick={() => handleServiceChange(service.id)}
                  className={`p-3 rounded-xl transition-all duration-300 flex flex-col items-center justify-center ${
                    activeService === service.id 
                      ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg' 
                      : 'hover:bg-gray-100 text-gray-700'
                  }`}
                >
                  <span className="text-xl mb-1">{service.icon}</span>
                  <span className="text-xs font-medium text-center">{service.name}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-full p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Спасибо что выбираете "888"!</h1>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 mb-6 text-left">
  <div className="flex items-center mb-3">
    <Calendar className="w-5 h-5 text-gray-500 mr-3 flex-shrink-0" />
    <span className="font-semibold">{formatCurrentDate()}</span>
  </div>
  
  <div className="flex items-center mb-3">
    <Phone className="w-5 h-5 text-gray-500 mr-3 flex-shrink-0" />
    <span className="truncate">{formData.phone}</span>
  </div>
</div>
        </div>
      </div>
    );
  }

  const renderMassageContent = () => (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6 text-white text-center">
        <h1 className="text-xl font-bold mb-2">Добро пожаловать!</h1>
      </div>

      <div className="p-6 space-y-6">
        {/* Personal Information */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-800 flex items-center">
            <User className="w-5 h-5 mr-2 flex-shrink-0" />
            Персональные данные
          </h3>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Имя Фамилия</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
              placeholder="Введите ваше имя"
              required
            />
          </div>
          <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Дата рождения</label>
  <input
    type="date"
    value={formData.birthday}
    onChange={(e) => handleInputChange('birthday', e.target.value)}
    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
    max={new Date().toISOString().split('T')[0]} // Prevent future dates
  />
</div>

          <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Телефон *</label>
  <input
    type="tel"
    inputMode="tel"
    autoComplete="tel"
    value={formData.phone}
    onChange={(e) => handleInputChange('phone', e.target.value)}
    onFocus={(e) => {
      // If empty, set to +7 7
      if (e.target.value === '') {
        handleInputChange('phone', '+7 7');
      }
    }}
    className={`w-full p-3 border ${
      formData.phone && !isValidPhoneNumber(formData.phone)
        ? 'border-red-500 focus:ring-red-500'
        : 'border-gray-300 focus:ring-purple-500'
    } rounded-lg focus:border-transparent transition-all duration-300`}
    placeholder="+7 777 777 77 77"
    required
  />
  {formData.phone && !isValidPhoneNumber(formData.phone) && (
    <p className="text-sm text-red-600 mt-1">Неверный формат номера</p>
  )}
</div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">Пол*</label>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="gender"
                  value="male"
                  checked={formData.gender === 'male'}
                  onChange={(e) => handleInputChange('gender', e.target.value)}
                  className="mr-2 text-purple-600 focus:ring-purple-500"
                />
                <span className="text-sm">Мужской</span>
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  checked={formData.gender === 'female'}
                  onChange={(e) => handleInputChange('gender', e.target.value)}
                  className="mr-2 text-purple-600 focus:ring-purple-500"
                />
                <span className="text-sm">Женский</span>
              </label>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleFormSubmit}
          disabled={!formData.gender || !formData.phone || isSubmitting}
          className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-4 px-6 rounded-xl font-semibold hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Отправка…' : 'Отправить'}
        </button>
      </div>
    </div>
  );

  const renderKitchenContent = () => (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-600 to-red-600 p-6 text-white text-center">
        <h1 className="text-xl font-bold mb-2">Кухня и Бар</h1>
        <div className="flex items-center justify-center text-sm opacity-90">
          <ShoppingCart className="w-4 h-4 mr-1 flex-shrink-0" />
          <span>Меню и заказ</span>
        </div>
      </div>

      <div className="p-6">
        {/* Cart Summary */}
        {kitchenCart.length > 0 && (
          <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 mb-6">
            <h3 className="font-semibold text-orange-800 mb-2">Ваш заказ:</h3>
            <div className="space-y-2 max-h-32 overflow-y-auto">
              {kitchenCart.map(item => (
                <div key={item.id} className="flex justify-between items-center text-sm">
                  <span className="flex-1 truncate">{item.name} x{item.quantity}</span>
                  <span className="font-semibold ml-2 flex-shrink-0">{item.price * item.quantity} ₸</span>
                </div>
              ))}
            </div>
            <div className="border-t border-orange-200 mt-3 pt-3 flex justify-between items-center font-bold text-orange-800">
              <span>Итого:</span>
              <span>{getCartTotal(kitchenCart)} ₸</span>
            </div>
            <button 
              type="button"
              onClick={() => handleOrder('kitchen')}
              disabled={isOrdering}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 px-4 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-md mt-3 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isOrdering ? 'Оформляем...' : 'Заказать'}
            </button>
          </div>
        )}

        {/* Menu Categories */}
        <div className="space-y-6">
          {menuItems.map(category => (
            <div key={category.category}>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full text-sm mr-3 flex-shrink-0">
                  {category.category}
                </span>
              </h3>
              <div className="space-y-3">
              {category.items.map(item => (
  <div key={item.id} className="bg-gray-50 rounded-xl p-4">
    <div className="flex justify-between items-start gap-4">
      <div className="flex-1 min-w-0">
        <div className="mb-2">
          <h4 className="font-semibold text-gray-800">
            {isItemExpanded(item.id, 'kitchen') || !shouldTruncate(item.name, 40) 
              ? item.name 
              : getTruncatedText(item.name, 40)
            }
            {shouldTruncate(item.name, 40) && (
              <button
                type="button"
                onClick={() => toggleItemExpanded(item.id, 'kitchen')}
                className="ml-2 text-xs text-blue-600 hover:text-blue-800 underline"
              >
                {isItemExpanded(item.id, 'kitchen') ? 'свернуть' : 'развернуть'}
              </button>
            )}
          </h4>
        </div>
        <div className="mb-2">
          <p className="text-sm text-gray-600">
            {isItemExpanded(item.id, 'kitchen') || !shouldTruncate(item.description) 
              ? item.description 
              : getTruncatedText(item.description)
            }
            {shouldTruncate(item.description) && (
              <button
                type="button"
                onClick={() => toggleItemExpanded(item.id, 'kitchen')}
                className="ml-2 text-xs text-blue-600 hover:text-blue-800 underline"
              >
                {isItemExpanded(item.id, 'kitchen') ? 'свернуть' : 'развернуть'}
              </button>
            )}
          </p>
        </div>
        <p className="text-lg font-bold text-orange-600">{item.price} ₸</p>
      </div>
      <div className="flex items-center space-x-2 flex-shrink-0">
        {getCartItemCount(item.id, 'kitchen') > 0 && (
          <button
            type="button"
            onClick={() => removeFromCart(item.id, 'kitchen')}
            className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
          >
            <Minus className="w-4 h-4" />
          </button>
        )}
        {getCartItemCount(item.id, 'kitchen') > 0 && (
          <span className="w-8 text-center font-semibold">{getCartItemCount(item.id, 'kitchen')}</span>
        )}
        <button
          type="button"
          onClick={() => addToCart(item, 'kitchen')}
          className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
))}


                </div>
            </div>
          ))}
        </div>

        {kitchenCart.length > 0 && (
          <button 
            type="button"
            onClick={() => handleOrder('kitchen')} 
            disabled={isOrdering}
            className="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-4 px-6 rounded-xl font-semibold hover:from-orange-700 hover:to-red-700 transition-all duration-300 shadow-lg mt-6 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isOrdering ? 'Оформляем заказ...' : `Оформить заказ (${getCartTotal(kitchenCart)} ₸)`}
          </button>
        )}
      </div>
    </div>
  );

  const renderServicesContent = () => (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6 text-white text-center">
        <h1 className="text-xl font-bold mb-2">Банные услуги</h1>
        <div className="flex items-center justify-center text-sm opacity-90">
          <span className="mr-1">🛁</span>
          <span>Выберите услугу</span>
        </div>
      </div>
  
      <div className="p-6">
        {/* Cart Summary */}
        {servicesCart.length > 0 && (
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
            <h3 className="font-semibold text-blue-800 mb-2">Ваш заказ:</h3>
            <div className="space-y-2 max-h-32 overflow-y-auto">
              {servicesCart.map(item => (
                <div key={item.id} className="flex justify-between items-center text-sm">
                  <span className="flex-1 truncate">{item.name} x{item.quantity}</span>
                  <span className="font-semibold ml-2 flex-shrink-0">{item.price * item.quantity} ₸</span>
                </div>
              ))}
            </div>
            <div className="border-t border-blue-200 mt-3 pt-3 flex justify-between items-center font-bold text-blue-800">
              <span>Итого:</span>
              <span>{getCartTotal(servicesCart)} ₸</span>
            </div>
          </div>
        )}
     
     {servicesCart.length > 0 && (
          <button 
            type="button"
            onClick={() => handleOrder('services')} 
            disabled={isOrdering}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg mt-6 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isOrdering ? 'Оформляем заказ...' : `Оформить заказ (${getCartTotal(servicesCart)} ₸)`}
          </button>
        )}
        <div className="space-y-4">
        {productItems.map(service => (
  <div key={service.id} className="bg-gray-50 rounded-xl p-4">
    <div className="flex justify-between items-start gap-4">
      <div className="flex-1 min-w-0">
        <div className="mb-2">
          <h4 className="font-semibold text-gray-800">
            {isItemExpanded(service.id, 'services') || !shouldTruncate(service.name, 40) 
              ? service.name 
              : getTruncatedText(service.name, 40)
            }
            {shouldTruncate(service.name, 40) && (
              <button
                type="button"
                onClick={() => toggleItemExpanded(service.id, 'services')}
                className="ml-2 text-xs text-blue-600 hover:text-blue-800 underline"
              >
                {isItemExpanded(service.id, 'services') ? 'свернуть' : 'развернуть'}
              </button>
            )}
          </h4>
        </div>
        <div className="mb-2">
          <p className="text-sm text-gray-600">
            {isItemExpanded(service.id, 'services') || !shouldTruncate(service.description) 
              ? service.description 
              : getTruncatedText(service.description)
            }
            {shouldTruncate(service.description) && (
              <button
                type="button"
                onClick={() => toggleItemExpanded(service.id, 'services')}
                className="ml-2 text-xs text-blue-600 hover:text-blue-800 underline"
              >
                {isItemExpanded(service.id, 'services') ? 'свернуть' : 'развернуть'}
              </button>
            )}
          </p>
        </div>
        <p className="text-lg font-bold text-blue-600">{service.price} ₸</p>
      </div>
      <div className="flex items-center space-x-2 flex-shrink-0">
        {getCartItemCount(service.id, 'services') > 0 && (
          <button
            type="button"
            onClick={() => removeFromCart(service.id, 'services')}
            className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
          >
            <Minus className="w-4 h-4" />
          </button>
        )}
        {getCartItemCount(service.id, 'services') > 0 && (
          <span className="w-8 text-center font-semibold">{getCartItemCount(service.id, 'services')}</span>
        )}
        <button
          type="button"
          onClick={() => addToCart(service, 'services')}
          className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
))}

        </div>
      </div>
    </div>
  );


  const renderOrderForm = () => {
    const currentCart = activeService === 'kitchen' ? kitchenCart : servicesCart;
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md">
          {/* Header */}
          <div className="bg-gradient-to-r from-orange-600 to-red-600 p-6 text-white text-center rounded-t-3xl">
            <h1 className="text-xl font-bold mb-2">Оформление заказа</h1>
            <div className="flex items-center justify-center text-sm opacity-90">
              <ShoppingCart className="w-4 h-4 mr-1 flex-shrink-0" />
              <span>Детали заказа</span>
            </div>
          </div>
  
          <div className="p-6 space-y-6">
            {/* Order Summary */}
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
              <h3 className="font-semibold text-orange-800 mb-3">Ваш заказ:</h3>
              <div className="space-y-2 max-h-32 overflow-y-auto">
                {currentCart.map(item => (
                  <div key={item.id} className="flex justify-between items-center text-sm">
                    <span className="flex-1 truncate">{item.name} x{item.quantity}</span>
                    <span className="font-semibold ml-2 flex-shrink-0">{item.price * item.quantity} ₸</span>
                  </div>
                ))}
              </div>
              <div className="border-t border-orange-200 mt-3 pt-3 flex justify-between items-center font-bold text-orange-800">
                <span>Итого:</span>
                <span>{getCartTotal(currentCart)} ₸</span>
              </div>
            </div>
  
            {/* Personal Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                <User className="w-5 h-5 mr-2 flex-shrink-0" />
                Персональные данные
              </h3>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Имя</label>
                <input
                  type="text"
                  value={orderFormData.name}
                  onChange={(e) => setOrderFormData(prev => ({ ...prev, name: e.target.value }))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                  placeholder="Введите ваше полное имя"
                />
              </div>
  
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Телефон *</label>
                <input
                  type="tel"
                  inputMode="tel"
                  autoComplete="tel"
                  value={orderFormData.phone}
                  onChange={(e) => {
                    const formattedPhone = formatPhoneNumber(e.target.value);
                    setOrderFormData(prev => ({ ...prev, phone: formattedPhone }));
                  }}
                  onFocus={(e) => {
                    // If empty, set to +7 7
                    if (e.target.value === '') {
                      setOrderFormData(prev => ({ ...prev, phone: '+7 7' }));
                    }
                  }}
                  className={`w-full p-3 border ${
                    orderFormData.phone && !isValidPhoneNumber(orderFormData.phone)
                      ? 'border-red-500 focus:ring-red-500'
                      : 'border-gray-300 focus:ring-orange-500'
                  } rounded-lg focus:border-transparent transition-all duration-300`}
                  placeholder="+7 777 777 77 77"
                  required
                />
                {orderFormData.phone && !isValidPhoneNumber(orderFormData.phone) && (
                  <p className="text-sm text-red-600 mt-1">
                    Введите номер в формате +7XXXXXXXXXX
                  </p>
                )}
              </div>
            </div>
  
            {/* Buttons */}
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setShowOrderForm(false)}
                className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-xl font-semibold hover:bg-gray-600 transition-all duration-300"
              >
                Отмена
              </button>
              <button
                type="button"
                onClick={() => {
                  if (activeService === 'kitchen') {
                    sendKitchenOrderToService();
                  } else if (activeService === 'services') {
                    sendProductOrderToService();
                  }
                }}
                disabled={!orderFormData.phone || currentCart.length === 0 || isOrdering}
                className="flex-1 bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-orange-700 hover:to-red-700 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isOrdering ? 'Оформляем…' : 'Заказать'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-100">
      <div className="container mx-auto px-4 py-6 max-w-md">
        {/* Services Menu Bar */}
        <div className="bg-white rounded-2xl shadow-lg mb-4 p-2">
          <div className="grid grid-cols-2 gap-1">
            {services.map(service => (
              <button
                key={service.id}
                type="button"
                onClick={() => handleServiceChange(service.id)}
                className={`p-3 rounded-xl transition-all duration-300 flex flex-col items-center justify-center ${
                  activeService === service.id 
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg' 
                    : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                <span className="text-xl mb-1">{service.icon}</span>
                <span className="text-xs font-medium text-center">{service.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Dynamic Content Based on Active Service */}
        {activeService === 'kitchen' && renderKitchenContent()}
        {activeService === 'services' && renderServicesContent()}
      </div>
      {showOrderForm && renderOrderForm()}
    </div>
  );
};

export default QRBookingApp;
